import React from 'react';

interface InstitutionAccountsSkeletonProps {
  count?: number;
}

export default function InstitutionAccountsSkeleton({ count = 6 }: InstitutionAccountsSkeletonProps) {
  return (
    <div className="divide-y divide-gray-100">
      {[...Array(count)].map((_, index) => (
        <div key={`skeleton-${index}`} className={`py-3 px-4 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
          <div className="flex flex-row justify-between items-center w-full">
            <div className="w-40 h-4 bg-gray-200 animate-pulse rounded" />
            <div className="w-24 h-4 bg-gray-200 animate-pulse rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}
